import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('welcome-to-louis', () =>
    importWithFallback(
        /* webpackMode: "eager" */
        () => import('./welcome')
        ),
);
